import { AlertTitle, ColoredAlert, Tooltip, TooltipContent, TooltipTrigger } from '@bpinternal/ui-kit-next'
import { AlertTriangle, ExternalLink } from 'lucide-react'
import { getCdmStudioUrl } from '~/shared/configurations'

type Props = {
  botId: string
}

export const PublishAlert = ({ botId }: Props) => {
  return (
    <ColoredAlert color="amber" className="mt-2">
      <AlertTriangle className="size-5" />
      <AlertTitle className="mb-0 flex flex-wrap gap-1">
        <p className="self-center">
          You’re not using the latest version of Conversation Insights. Publish your bot to update and keep collecting
          insights from your conversations.
        </p>
        <Tooltip>
          <TooltipTrigger>
            <span className="underline">Why this happens</span>
          </TooltipTrigger>
          <TooltipContent className="max-w-96">
            <p>
              Conversation Insights is currently in open beta. When we release improvements or fixes, you’ll need to
              publish your bot again to re-enable the feature. Remember you can always save stable versions of your bot
              using Version History.
            </p>
          </TooltipContent>
        </Tooltip>
        <a
          href={getCdmStudioUrl(botId)}
          className="ml-2 flex items-center gap-1 text-sm text-brand-700 underline hover:text-brand-600"
          target="_blank"
          rel="noopener noreferrer"
        >
          Open Studio
          <ExternalLink className="h-3 w-3" />
        </a>
      </AlertTitle>
    </ColoredAlert>
  )
}
